// Bold sign limits due date to 180 days in the future
// use 178 days to be safe and avoid time zone issues
export const BOLD_SIGN_SAFE_FUTURE_DUE_DATE_DAYS = 178;

export const REVIEWER_DUE_DATE_MESSAGES = {
  PAST_DUE_DATE: "Reviewer due date cannot be in the past",
  SIGNER_MIN_FUTURE: "Signer due date must be at least 1 day in the future (based on UTC)",
  AFTER_SUBMISSION: "Due date must be before submission due date",
  AFTER_NEXT_REVIEWER:
    "Due date must be before the next reviewer's due date if priority order is selected",
  WITHIN_BOLD_SIGN_WINDOW: `Due date must be within ${BOLD_SIGN_SAFE_FUTURE_DUE_DATE_DAYS} days`,
};

// Drift-into-invalid messages — suppressed by consumers when the persisted reviewer is unchanged.
export const GRANDFATHERABLE_REVIEWER_DUE_DATE_MESSAGES: ReadonlySet<string> = new Set([
  REVIEWER_DUE_DATE_MESSAGES.PAST_DUE_DATE,
  REVIEWER_DUE_DATE_MESSAGES.SIGNER_MIN_FUTURE,
  REVIEWER_DUE_DATE_MESSAGES.AFTER_SUBMISSION,
  REVIEWER_DUE_DATE_MESSAGES.AFTER_NEXT_REVIEWER,
]);
